import React from "react"
import { Navigate, useNavigate } from "react-router"

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      
      <div className="bg-white min-h-full flex flex-col lg:relative">
        <div className="flex-grow flex flex-col">
          <main className="flex-grow flex flex-col bg-white">
            <div className="flex-grow mx-auto max-w-7xl w-full flex flex-col px-4 sm:px-6 lg:px-8">
              <div className="flex-shrink-0 pt-10 sm:pt-16">
                <a href="/" className="inline-flex">
                  <span className="sr-only">Workflow</span>
                  <img
                    className="h-12 w-auto"
                    src="/assets/logo.png"
                    alt=""
                  />
                </a>
              </div>
              <div className="flex-shrink-0 my-auto py-16 sm:py-32">
                <p className="text-base font-semibold text-indigo-600">404</p>
                <h1 className="mt-2 text-4xl font-bold text-gray-900 tracking-tight sm:text-5xl sm:tracking-tight">
                  Page non trouvée
                </h1>
                <p className="mt-2 text-base text-gray-500">Désolez on a pas trouvé la page que vous cherchez.</p>
                <div className="mt-6">
                  <a className="text-base cursor-pointer font-medium text-indigo-600 hover:text-indigo-500" onClick={() => navigate('/')}>
                    Revenir en arrière<span aria-hidden="true"> &rarr;</span>
                  </a>
                </div>
              </div>
            </div>
          </main>
        </div>
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src="/assets/404.jpeg"
            alt=""
          />
        </div>
      </div>
    </>
  )
}
